import { useBackNavigation } from "@wags/tanstack-start/browser";
import { DogNotFound } from "@/features/listings";

export function DogRouteNotFound() {
    const handleBack = useBackNavigation();
    return <DogNotFound onBack={handleBack} />;
}
